module.exports = __webpack_public_path__ + "assets/img/tiao.d56d80ac.png";